import { render, staticRenderFns } from "./AccessControlList.vue?vue&type=template&id=604674ac&scoped=true"
import script from "./AccessControlList.vue?vue&type=script&lang=js"
export * from "./AccessControlList.vue?vue&type=script&lang=js"
import style0 from "./AccessControlList.vue?vue&type=style&index=0&id=604674ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604674ac",
  null
  
)

export default component.exports